var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('download-type-button');
import { breakpoints, theme } from '@shapeable/theme';
import { Icons } from '../icons';
export var DownloadTypeButtonDefaultProps = {
  type: 'pdf',
  color: '#000',
  backgroundColor: '#FFF'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: 16px;\n    font-size: ", ";\n    text-transform: uppercase;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    font-family: ", ";\n    text-decoration: none;\n    padding: ", " ", ";\n\n    ", "\n\n    &:hover {\n      filter: brightness(1.2);\n    }\n  "], ["\n    border-radius: 16px;\n    font-size: ", ";\n    text-transform: uppercase;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    font-family: ", ";\n    text-decoration: none;\n    padding: ", " ", ";\n\n    ", "\n\n    &:hover {\n      filter: brightness(1.2);\n    }\n  "])), theme.FONT_SIZE(12), theme.FONT('sans'), theme.UNIT(2), theme.UNIT(3.5), function (_a) {
    var color = _a.color,
        backgroundColor = _a.backgroundColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n       ", ";\n       color: ", " !important;\n       background: ", ";\n    "], ["\n       ", ";\n       color: ", " !important;\n       background: ", ";\n    "])), theme.FILL(color || '#000'), color, backgroundColor);
  })
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 500;\n  "], ["\n    font-weight: 500;\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: ", ";\n    width: 14px;\n    height: 14px;\n  "], ["\n    margin-right: ", ";\n    width: 14px;\n    height: 14px;\n  "])), theme.UNIT(2))
}); // -------- Components -------->

var My = {
  Container: styled.a(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.span.attrs(cls.attr('label'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icons.Download)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var DownloadTypeButton = function DownloadTypeButton(props) {
  var className = props.className,
      href = props.href,
      children = props.children,
      color = props.color,
      backgroundColor = props.backgroundColor,
      type = props.type;

  var onClick = function onClick(e) {
    e.stopPropagation();
  };

  return React.createElement(My.Container, {
    onClick: onClick,
    color: color,
    backgroundColor: backgroundColor,
    href: href,
    className: cls.name(className)
  }, React.createElement(My.Icon, null), React.createElement(My.Label, null, type || children));
};
DownloadTypeButton.defaultProps = DownloadTypeButtonDefaultProps;
DownloadTypeButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;